import { useEffect, useState } from "react";
import api from "../../api/axios";
import { Spinner, Toast } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import MainLayout from "../layoutpage/MainLayout";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useMinimumPercent } from "../../utilities/MinimumPercentContext";
import { formatDate } from "../../utilities/DateFormat";
import Footer from "../../components/Footer";

export default function ManagerBookingDashboard({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const { minimumPercent, setMinimumPercent } = useMinimumPercent(); // Access minimumPercent and setMinimumPercent from context
  console.log("minimumPercent", minimumPercent);

  const handlePercentChange = (value) => {
    setMinimumPercent(value);
    localStorage.setItem("minimumPercent", value);
  };
  useEffect(() => {
    const savedPercent = localStorage.getItem("minimumPercent");
    if (savedPercent) setMinimumPercent(Number(savedPercent));
  }, []);

  const [bookings, setBookings] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const navigate = useNavigate();

  const getStatusBadgeClass = (statusType) => {
    switch (statusType.toLowerCase()) {
      case "available":
        return "bg-success"; // green
      case "booked":
        return "bg-warning"; // yellow
      case "sold":
        return "bg-danger"; // red
      default:
        return "bg-secondary"; // gray
    }
  };
  const getPendingCollectionTotal = (booking) =>
    (booking.payments || [])
      .filter((payment) => payment.payment_status === "pending")
      .reduce((total, payment) => total + Number(payment.amount || 0), 0);
  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const loadBookings = () => {
    setLoading(true);
    api
      .get("/api/manager/bookings")
      .then((res) => {
        console.log("manager booking", res.data);
        setBookings(res.data);
        setFiltered(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadBookings();
  }, []);

  // SEARCH
  useEffect(() => {
    const f = bookings.filter((b) =>
      `${b.user?.name} ${b.property?.name} ${b.unit?.unit_number}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFiltered(f);
  }, [search, bookings]);

  // SORTING
  const sortData = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filtered].sort((a, b) => {
      const valA = a[field]?.toString().toLowerCase();
      const valB = b[field]?.toString().toLowerCase();
      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFiltered(sorted);
  };

  const downloadReceipt = async (receiptId, invoiceNumber) => {
    if (!receiptId) return;

    try {
      const res = await api.get(`/api/invoices/${receiptId}/pdf`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Receipt-${invoiceNumber || receiptId}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.log(err);
      toast.error("Unable to download receipt.");
    }
  };

  // APPROVE / REJECT
  const handleDecision = async (id, decision) => {
    try {
      const res = await api.post(`/api/manager/bookings/${id}/decision`, {
        decision,
      });

      if (decision === "approve") {
        toast.success(`Payments ${decision}d successfully`);
        if (res.data?.receipt?.id) {
          await downloadReceipt(
            res.data.receipt.id,
            res.data.receipt.invoice_number
          );
        }
      } else {
        toast.error(`Booking ${decision}ed `);
      }

      loadBookings();
      closeModal();
    } catch (err) {
      console.log(err);
      toast.error("Decision failed.");
    }
  };

  // OPEN MODAL
  const openModal = (booking) => {
    setSelectedBooking(booking);
    setShowModal(true);
  };

  // CLOSE MODAL
  const closeModal = () => {
    setShowModal(false);
    setSelectedBooking(null);
  };

  return (
    <>

      <div
        className="container-fluid"
     
      >
        <div className="card shadow-lg p-4 mt-4">
          <h2 className="mb-4 text-center fw-bold text-primary">
            Pending Payments
          </h2>

          {/* MINIMUM PAYMENT PERCENT INPUT */}
          <div className="mb-3">
            <label className="fw-semibold">
              Minimum Payable Percentage (%)
            </label>
            <input
              type="number"
              className="form-control"
              value={minimumPercent}
              onChange={(e) => handlePercentChange(Number(e.target.value))}
            />
          </div>

          {/* back button */}
          <button
            className="btn btn-secondary mb-3 mt-3 w-25"
            onClick={() => navigate(-1)}
          >
            &larr; Back
          </button>
          {/* Search */}
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search by user / property / unit"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : filtered.length === 0 ? (
            <h5 className="text-center text-muted py-4">No pending bookings</h5>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-primary">
                  <tr>
                    <th
                      onClick={() => sortData("id")}
                      style={{ cursor: "pointer" }}
                    >
                      ID{" "}
                      {sortField === "id"
                        ? sortOrder === "asc"
                          ? "▲"
                          : "▼"
                        : ""}
                    </th>
                    <th>User</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Property</th>
                    <th>Unit</th>
                    <th>Invoice Created Date</th>
                    <th>Last Payment Date</th>
                    <th>Paid / Total</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {filtered.map((b) => (
                    <tr key={b.id}>
                      <td>{b.id}</td>
                      <td>{b.user?.name}</td>
                      <td>{b.user?.email}</td>
                      <td>{b.user?.mobile_number}</td>
                      <td>{b.property?.name}</td>
                      <td>{b.unit?.unit_number}</td>
                      <td>{formatDate(b.check_in_date) || b.check_in_date}</td>
                      <td
                        style={{
                          color:
                            new Date(b.check_out_date) < new Date()
                              ? "red"
                              : "black",
                        }}
                      >
                        {formatDate(b.check_out_date) || b.check_out_date}
                      </td>
                      <td className="fw-bold text-success">
                        ৳{b.paid_amount} / ৳{b.total_amount}
                        {getPendingCollectionTotal(b) > 0 && <div className="small text-warning-emphasis fw-normal">৳{getPendingCollectionTotal(b).toFixed(2)} submitted; awaiting confirmation</div>}
                      </td>
                      <td>
                        <button
                          className="btn btn-info btn-sm me-2"
                          onClick={() => openModal(b)}
                        >
                          View
                        </button>

                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => handleDecision(b.id, "approve")}
                        >
                          Approve
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDecision(b.id, "reject")}
                        >
                          Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      
        </div>
      </div>

      {/* ==========================
          BOOKING DETAILS MODAL
      =========================== */}
      {showModal && selectedBooking && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Booking Details (ID: {selectedBooking.id})
                </h5>
                <button className="btn-close" onClick={closeModal}></button>
              </div>

              <div className="modal-body">
                <h6 className="fw-bold">User Information</h6>
                <p>Name: {selectedBooking.user?.name}</p>
                <p>Email: {selectedBooking.user?.email}</p>
                <p>Phone: {selectedBooking.user?.mobile_number}</p>

                <hr />

                <h6 className="fw-bold">Property & Unit</h6>
                <p>Property: {selectedBooking.property?.name}</p>
                <p>Unit: {selectedBooking.unit?.unit_number}</p>
                <p className="text-success fw-bold">
                  Paid: ৳{selectedBooking.paid_amount} / Total: ৳
                  {selectedBooking.total_amount}
                </p>
                {getPendingCollectionTotal(selectedBooking) > 0 && <p className="text-warning-emphasis fw-semibold">৳{getPendingCollectionTotal(selectedBooking).toFixed(2)} submitted and awaiting confirmation. This amount is not yet counted as paid.</p>}

                <hr />

                <h6 className="fw-bold">Booking Info</h6>
                <span
                  className={`badge ${getStatusBadgeClass(
                    selectedBooking.unit.status.status_type
                  )}`}
                >
                  {selectedBooking.unit.status.status_type}
                </span>
                <p>Created: {selectedBooking.created_at}</p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>{" "}
                <button
                  className="btn btn-success btn-sm me-2"
                  onClick={() => handleDecision(selectedBooking.id, "approve")}
                >
                  Approve
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDecision(selectedBooking.id, "reject")}
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
    </>
  );
}
